var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchaseActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.75005C16.6922 2.58608 15.8562 2.5 15 2.5C8.09644 2.5 2.5 8.09644 2.5 15C2.5 21.9036 8.09644 27.5 15 27.5C21.9036 27.5 27.5 21.9036 27.5 15C27.5 14.1438 27.4139 13.3078 27.25 12.5",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1543 3.17086C28.5222 2.80645 28.5249 2.21286 28.1605 1.84505C27.7961 1.47724 27.2025 1.47449 26.8347 1.8389L28.1543 3.17086ZM26.8569 9.68711C27.3746 9.69419 27.8 9.28024 27.8071 8.76252C27.8142 8.24481 27.4003 7.81937 26.8825 7.81228L26.8569 9.68711ZM22.1874 3.11704C22.1803 2.59932 21.7548 2.1854 21.2371 2.19252C20.7194 2.19964 20.3055 2.6251 20.3126 3.14282L22.1874 3.11704ZM22.4769 8.79591L28.1543 3.17086L26.8347 1.8389L21.1572 7.46395L22.4769 8.79591ZM22.6226 7.54797C22.5565 7.53625 22.5216 7.51087 22.5023 7.49014L21.1318 8.76972C21.4396 9.09942 21.8459 9.3146 22.2956 9.39424L22.6226 7.54797ZM22.5023 7.49014C22.4843 7.47085 22.4623 7.43706 22.4517 7.37693L20.6054 7.70357C20.6766 8.10599 20.8564 8.47478 21.1318 8.76972L22.5023 7.49014ZM22.2956 9.39424C23.564 9.61887 25.8108 9.67279 26.8569 9.68711L26.8825 7.81228C25.7981 7.79744 23.7126 7.74101 22.6226 7.54797L22.2956 9.39424ZM20.3126 3.14282C20.327 4.18884 20.381 6.43538 20.6054 7.70357L22.4517 7.37693C22.2588 6.28683 22.2023 4.20138 22.1874 3.11704L20.3126 3.14282Z",
    fill: "#2177FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.25C13.6193 11.25 12.5 12.0895 12.5 13.125C12.5 14.1605 13.6193 15 15 15C16.3807 15 17.5 15.8395 17.5 16.875C17.5 17.9105 16.3807 18.75 15 18.75M15 11.25C16.0885 11.25 17.0145 11.7718 17.3577 12.5M15 11.25V10M15 18.75C13.9115 18.75 12.9855 18.2282 12.6423 17.5M15 18.75V20",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseActive);
export default __webpack_public_path__ + "static/media/purchaseActive.1b2912a106774b03eeb45cc5fb55ec9b.svg";
export { ForwardRef as ReactComponent };